// extracted by mini-css-extract-plugin
export default {"container":"TaskContainer_container__WFapi","flex":"TaskContainer_flex__-TlKP","body":"TaskContainer_body__fYGs9","footer":"TaskContainer_footer__mEtuT"};